import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import BufferTabView from 'buffers/BufferTabView';
import {REGISTRY_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import EntityMap from 'registry/entity-map/EntityMap';
import EntityMapBetaBanner from 'registry/entity-map/EntityMapBetaBanner';
import {
  EntityMapUnavailableReason,
  EntityMapUnavailableView,
} from 'registry/entity-map/EntityMapUnavailableView';
import EntityMapTabState from 'registry/entity-map/tab/EntityMapTabState';

export default class EntityMapTabView extends BufferTabView<EntityMapTabState> {
  openedEntityMapTabEvent = REGISTRY_ANALYTICS_ACTIONS.OPENED_ENTITY_MAP_TAB;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  private isEntityArchived(): boolean {
    return this.model.get('model').isArchived();
  }

  override afterAttach(): void {
    super.afterAttach();
    analytics.trackEvent(this.openedEntityMapTabEvent, {
      mainEntityId: this.model.get('model').id,
      isArchived: this.isEntityArchived(),
    });
  }

  override render(): EntityMapTabView {
    const model = this.model.get('model');

    const entityMap = this.isEntityArchived() ? (
      <EntityMapUnavailableView unavailableReason={EntityMapUnavailableReason.ARCHIVED} />
    ) : (
      <EntityMap entityId={model.id} />
    );

    renderToDOM(
      <>
        <EntityMapBetaBanner />
        {entityMap},
      </>,
      this.el
    );

    return this;
  }

  override remove(): EntityMapTabView {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}

EntityMapTabView.initClass();
